import script from "./FormDateField.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormDateField.vue?vue&type=script&lang=ts&setup=true"

import "./FormDateField.vue?vue&type=style&index=0&id=08e6c7ca&lang=scss"

const __exports__ = script;

export default __exports__